const SEARCH_PATH = document.documentElement.dataset.coutureiaSearchPath || '/search';

function localizedPagePath(handle) {
  const prefix = SEARCH_PATH.endsWith('/search') ? SEARCH_PATH.slice(0, -7) : '';
  return `${prefix}/pages/${handle}`.replace(/\/{2,}/g, '/');
}

function normalizeLabel(value) {
  return String(value || '').replace(/\s+/g, ' ').trim().toLocaleLowerCase();
}

function mobileHubHandle(anchor) {
  if (!(anchor instanceof HTMLAnchorElement)) return null;
  if (!anchor.matches('.menu-drawer__hub-link')) return null;

  const label = normalizeLabel(anchor.textContent);
  if (['men', 'männer', 'maenner', 'herren', 'hommes'].includes(label)) return 'men';
  if (['women', 'frauen', 'damen', 'femmes'].includes(label)) return 'women';
  return null;
}

function rewriteMobileHubAnchor(anchor) {
  const handle = mobileHubHandle(anchor);
  if (!handle) return;
  anchor.href = localizedPagePath(handle);
  anchor.dataset.coutureiaMobileHubRouting = handle;
}

function rewriteMobileHubLinks(root = document) {
  root.querySelectorAll?.('.menu-drawer__hub-link').forEach(rewriteMobileHubAnchor);
}

if (document.documentElement.dataset.coutureiaSearchFirst === 'true') {
  rewriteMobileHubLinks();

  document.addEventListener('click', (event) => {
    const anchor = event.target instanceof Element ? event.target.closest('.menu-drawer__hub-link') : null;
    if (anchor instanceof HTMLAnchorElement) rewriteMobileHubAnchor(anchor);
  }, true);

  new MutationObserver(() => rewriteMobileHubLinks()).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}
